import { DataGrid } from 'src/feature/data-grid/data-grid';
import { useDataGridSearchParams } from 'src/feature/data-grid/use-data-grid-search-params/use-data-grid-search-params';
import { Snackbar } from 'src/shared/snackbar/snackbar';
import { useTranslation } from 'react-i18next';
import { DEFAULT_DATA_GRID_MODEL } from 'src/config/data-grid.config';
import { useGetCposQuery } from 'src/core/service/cpo.service';
import { useCpoFilter } from './use-cpo-filter';
import { useCpoColumn } from './use-cpo-column';

export function CpoDataGrid(): React.JSX.Element {
  const columns = useCpoColumn();
  const filterDefinitionModel = useCpoFilter();
  const { model, onModelChange } = useDataGridSearchParams({
    ...DEFAULT_DATA_GRID_MODEL,
    sort: [
      {
        field: 'id',
        sort: 'asc',
      },
    ],
  });

  const { t } = useTranslation();
  // const { data: cpoList, error, isError, isLoading } = useGetListCpoQuery(null);
  const { data, isError, isLoading } = useGetCposQuery(null);

  if (!data) {
    return <div>an error has occured : no CPOs found</div>;
  }

  return (
    <>
      <DataGrid
        getRowId={(row) => {
          return row.id;
        }}
        columns={columns}
        filterDefinitionModel={filterDefinitionModel}
        loading={isLoading}
        model={model}
        onModelChange={onModelChange}
        rows={data.docs ?? []}
        rowCount={data.docs?.length ?? 0}
      />

      {isError && (
        <Snackbar variant="error" message={t('error.get-list-cpo-query')} />
      )}
    </>
  );
}
